import React from "react";

import "./../../css/HomeResults.css";
import Heading from "./../../ui/heading";
import ResultBarChart from "./ResultBarChart";
import { FactoryImage } from "../../assets/images";

const HomeResults = () => {
  return (
    <div className='home-results-grid'>
      <div className='home-results-content'>
        <div className='content-wrapper'>
          <div className='content-text'>
            <Heading variant='H2'>
              The Leader in Air Pollution Control & Baghouse Services
            </Heading>
            <p className='content-description'>
              PS Environmental Services, Inc. (PSE) offers baghouse and air
              pollution control services in California, Oregon, Washington,
              Nevada. We provide solutions to all your environmental problems in
              industrial and commercial facilities.
            </p>
          </div>
          <div className='experience-section'>
            <ul className='experience-list'>
              {["Innovation", "Analytics", "User Experience", "Promotion"].map(
                (item) => (
                  <li key={item} className='experience-item'>
                    <span>+</span> {item}
                  </li>
                )
              )}
            </ul>
            <div className='experience-details'>
              <div className='years-container'>
                <span className='years-number'>
                  <span className='years-number-strong'>40</span>+
                </span>
                <p className='years-text'>
                  Years of <br /> Experience
                </p>
              </div>
              <p className='experience-description'>
                as a baghouse company and are trusted by engineers and
                facilities in a wide range of industries, including steel,
                mining, power, cement, aluminum, and more. Under the leadership
                of our Founder, Joe Gaglione, and the senior leadership team,
                our friendly workers look forward to supporting your
                facility&apos;s needs.
              </p>
            </div>
          </div>
          <div className='success-section'>
            <h3 className='success-heading'>Our Success</h3>
            <div className='success-charts'>
              <ResultBarChart title='Project Complete' rate={92} />
              <ResultBarChart title='Happy Clients' rate={98} />
              <ResultBarChart title='Our Company Growth' rate={65} />
            </div>
          </div>
        </div>
      </div>
      <img src={FactoryImage} alt='' className='home-results-image' />
    </div>
  );
};

export default HomeResults;
